import React from "react";
import Button from "react-bootstrap/Button";
import SubheadCard from "./SubheadCard";

const DepartmentCard = ({
  item,
  index,
  formData,
  scheme,
  authData,
  activity,
  subheadCount,
  getOptions,
  handleDepartmentChange,
  handleSubheadChange,
  changeSubheadBudget,
  handleActivityChange,
  findSubActivitiesById,
  handleSubheadBudgetFormData,
  addNewActivity,
  deleteNewActivity,
  handleAddSubHead,
  handleDeleteSubHead,
}) => {
  return (
    <div className="card p-3">
      <>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="dropdown1" className="bold">
                Select Department Code
              </label>
              <select
                className="form-control"
                id="dropdown1"
                onChange={(e) =>
                  handleDepartmentChange(
                    e.target.value,
                    index,
                    `department${index}`,
                  )
                }
                value={formData.department_Array[index].department_id}
              >
                <option value="">---Select---</option>
                {getOptions(`department${index}`, "department").map(
                  (option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ),
                )}
              </select>
            </div>
          </div>
          <div className="col-md-8">
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th className="bold text-center">Level</th>
                  <th className="bold text-center">Department Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center">{item.department_level}</td>
                  <td className="text-center">{item.department_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
          {item.subHead.map((subhead, subheadIndex) => (
            <SubheadCard
              key={subheadIndex}
              subhead={subhead}
              subheadIndex={subheadIndex}
              deptIndex={index}
              scheme={scheme}
              authData={authData}
              activity={activity}
              formData={formData}
              getOptions={getOptions}
              handleSubheadChange={handleSubheadChange}
              handleActivityChange={handleActivityChange}
              findSubActivitiesById={findSubActivitiesById}
              handleSubheadBudgetFormData={handleSubheadBudgetFormData}
              addNewActivity={addNewActivity}
              deleteNewActivity={deleteNewActivity}
              changeSubheadBudget={changeSubheadBudget}
            />
          ))}
        </div>
        <div className="row justify-content-end">
          <div className="col-sm-6 d-flex justify-content-end">
            {subheadCount > 0 && (
              <Button
                variant="primary"
                onClick={() => handleAddSubHead(index)}
              >
                Add SubHead
              </Button>
            )}
            {formData.department_Array[index].subHead.length > 1 && (
              <Button
                variant="danger"
                onClick={() => handleDeleteSubHead(index)}
                className="ml-2"
              >
                Delete SubHead
              </Button>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default DepartmentCard;
